import React, { useState } from 'react';
import './css/header.scss';
import { Link } from 'react-router-dom';
import Logo from './assets/yapImg/yap-logo.png';
import {
    FaBars,
    FaTimes,
    FaEnvelope,
    FaPhone,
    FaFacebook,
    FaInstagram,
    FaTwitter,
    FaYoutube,
    FaLinkedin,
    FaList,
    FaChevronDown,
} from 'react-icons/fa';

const discoverLinks = [
    { to: '/advisory-board', label: 'Advisory Board', desc: 'Meet strategic leaders guiding YAP.' },
    { to: '/impact-stories', label: 'Impact Stories', desc: 'Real results from youth programs.' },
    { to: '/volunteer', label: 'Volunteer', desc: 'Join as mentor, field or digital volunteer.' },
    { to: '/faq', label: 'FAQ', desc: 'Answers about donations and programs.' },
];

const mediaLinks = [
    { to: '/projects', label: 'Projects' },
    { to: '/events', label: 'Events' },
    { to: '/gallery', label: 'Gallery' },
    { to: '/news', label: 'News' },
];

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [discoverOpen, setDiscoverOpen] = useState(false);
    const [mediaOpen, setMediaOpen] = useState(false);
    const [mobileDiscoverOpen, setMobileDiscoverOpen] = useState(false);
    const [mobileMediaOpen, setMobileMediaOpen] = useState(false);

    const toggleMenu = () => setIsOpen((prev) => !prev);

    const renderDesktopNav = () => (
        <div className="hidden items-center space-x-6 md:flex">
            <Link to="/" className="text-gray-700 transition hover:text-emerald-500">Home</Link>
            <Link to="/about" className="text-gray-700 transition hover:text-emerald-500">About</Link>

            <div className="relative" onMouseEnter={() => setMediaOpen(true)} onMouseLeave={() => setMediaOpen(false)}>
                <button type="button" onClick={() => setMediaOpen((prev) => !prev)} className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50">
                    Media <FaChevronDown className={`text-xs transition ${mediaOpen ? 'rotate-180' : ''}`} />
                </button>
                {mediaOpen && (
                    <div className="absolute left-0 top-12 z-50 w-56 overflow-hidden rounded-2xl border border-slate-200 bg-white p-2 shadow-2xl">
                        {mediaLinks.map((item) => (
                            <Link key={item.to} to={item.to} className="block rounded-lg px-3 py-2 text-sm text-slate-700 hover:bg-emerald-50 hover:text-emerald-700">
                                {item.label}
                            </Link>
                        ))}
                    </div>
                )}
            </div>

            <div className="relative" onMouseEnter={() => setDiscoverOpen(true)} onMouseLeave={() => setDiscoverOpen(false)}>
                <button
                    type="button"
                    onClick={() => setDiscoverOpen((prev) => !prev)}
                    className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-semibold text-emerald-700 transition hover:bg-emerald-100"
                >
                    Discover <FaChevronDown className={`text-xs transition ${discoverOpen ? 'rotate-180' : ''}`} />
                </button>
                {discoverOpen && (
                    <div className="absolute right-0 top-12 z-50 w-[360px] overflow-hidden rounded-2xl border border-slate-200 bg-white p-3 shadow-2xl">
                        <div className="mb-2 rounded-xl bg-[linear-gradient(120deg,_#022c22,_#065f46,_#10b981)] p-3 text-white">
                            <p className="text-xs uppercase tracking-[0.2em] text-emerald-100">Explore</p>
                            <p className="text-lg font-bold">Go Beyond Main Menu</p>
                        </div>
                        <div className="space-y-2">
                            {discoverLinks.map((item) => (
                                <Link key={item.to} to={item.to} className="block rounded-xl border border-transparent px-3 py-3 transition hover:border-emerald-100 hover:bg-emerald-50">
                                    <p className="font-semibold text-slate-800">{item.label}</p>
                                    <p className="text-xs text-slate-500">{item.desc}</p>
                                </Link>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            <Link to="/contact" className="text-gray-700 transition hover:text-emerald-500">Contact</Link>
            <Link to="/donate" className="rounded-lg bg-emerald-500 px-4 py-2 text-white transition hover:bg-emerald-600">Donate</Link>
        </div>
    );

    const renderMobileMenu = () => (
        isOpen && (
            <div className="border-t bg-white md:hidden">
                <div className="space-y-1 px-2 pb-3 pt-2">
                    <Link to="/" className="block rounded px-3 py-2 text-gray-700 hover:bg-emerald-50">Home</Link>
                    <Link to="/about" className="block rounded px-3 py-2 text-gray-700 hover:bg-emerald-50">About</Link>

                    <button type="button" onClick={() => setMobileMediaOpen((prev) => !prev)} className="flex w-full items-center justify-between rounded bg-slate-50 px-3 py-2 font-semibold text-slate-700">
                        Media
                        <FaChevronDown className={`text-xs transition ${mobileMediaOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {mobileMediaOpen && (
                        <div className="rounded-xl border border-slate-100 bg-slate-50/70 p-2">
                            {mediaLinks.map((item) => (
                                <Link key={item.to} to={item.to} className="block rounded px-3 py-2 text-sm text-gray-700 hover:bg-white">{item.label}</Link>
                            ))}
                        </div>
                    )}

                    <button type="button" onClick={() => setMobileDiscoverOpen((prev) => !prev)} className="flex w-full items-center justify-between rounded bg-emerald-50 px-3 py-2 font-semibold text-emerald-700">
                        Discover
                        <FaChevronDown className={`text-xs transition ${mobileDiscoverOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {mobileDiscoverOpen && (
                        <div className="rounded-xl border border-emerald-100 bg-emerald-50/50 p-2">
                            {discoverLinks.map((item) => (
                                <Link key={item.to} to={item.to} className="block rounded px-3 py-2 text-sm text-gray-700 hover:bg-white">{item.label}</Link>
                            ))}
                        </div>
                    )}

                    <Link to="/contact" className="block rounded px-3 py-2 text-gray-700 hover:bg-emerald-50">Contact</Link>
                    <Link to="/donate" className="block rounded bg-emerald-500 px-3 py-2 text-white hover:bg-emerald-600">Donate</Link>
                </div>
            </div>
        )
    );

    return (
        <>
            <div className="header sticky top-0 z-[60]">
                <div className="left">
                    <div className="social-icons">
                        <div className="gmail text-white"><FaEnvelope /><span>info@yap.org.pk</span></div>
                        <div className="phone text-white"><FaPhone /><span>+92-312-3456789</span></div>
                    </div>
                    <div className="links">
                        <span className="text-white">Follow us on :</span>
                        <a className="text-white" href="https://www.facebook.com/YAofPakistan" target="_blank" rel="noreferrer"><FaFacebook /></a>
                        <a className="text-white" href="https://www.instagram.com/yaopakistan/" target="_blank" rel="noreferrer"><FaInstagram /></a>
                        <a className="text-white" href="https://x.com/YAofPakistan" target="_blank" rel="noreferrer"><FaTwitter /></a>
                        <a className="text-white" href="https://www.youtube.com/@youthassociationofpakistan" target="_blank" rel="noreferrer"><FaYoutube /></a>
                        <a className="text-white" href="https://www.linkedin.com/company/youth-association-of-pakistan/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
                    </div>
                </div>
                <div className="right"><FaList /></div>

                <div className="bottom-header">
                    <nav className="main-header top-0 z-50">
                        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                            <div className="flex h-16 items-center justify-between">
                                <Link to="/" className="flex items-center space-x-2"><img src={Logo} alt="YAP" width={100} /></Link>
                                {renderDesktopNav()}
                                <div className="md:hidden">
                                    <button onClick={toggleMenu} className="text-gray-700 hover:text-emerald-500">{isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}</button>
                                </div>
                            </div>
                            {renderMobileMenu()}
                        </div>
                    </nav>
                </div>
            </div>

            <div className="bottom-header-mobile sticky top-0 z-[60]">
                <nav className="main-header top-0 z-50 bg-white shadow-sm">
                    <div className="mx-auto  p-5  max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="flex h-16 items-center justify-between">
                            <Link to="/" className="flex items-center space-x-2"><img src={Logo} alt="YAP" width={100} /></Link>
                            <div className="md:hidden">
                                <button onClick={toggleMenu} className="text-gray-700 hover:text-emerald-500">{isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}</button>
                            </div>
                        </div>
                        {renderMobileMenu()}
                    </div>
                </nav>
            </div>
        </>
    );
};

export default Header;
